import styled from 'styled-components'
import Flex from 'Components/Flex'

import {
  TEXT_GREY,
} from '@CSSVars/colors'


export const _ChartAndInfo = styled(Flex)`

`

export const _InfoHolder = styled.div`
  margin-left: 12px;
`

export const _Percent = styled.div`
  margin-bottom: 1px;
  font-weight: 600;
  font-size: 16px;
  line-height: 20px;
`

export const _Title = styled.div`
  margin-bottom: 6px;
  font-weight: normal;
  font-size: 14px;
  line-height: 17px;
  text-transform: capitalize;
`

export const _Subtitle = styled.div`
  color: ${TEXT_GREY};
`

